export default __webpack_public_path__ + "4a0f4c3ce754dc409187086c56e2f774.svg";